import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsFile
*  Настройки атрибута со ссылкой на файл
*/
export class AttributeRequirementsFile extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'File' })
  readonly type: string = 'File'


/**
  * extensions
  * Разрешённые для использования расширения файлов. Если список пуст, то разрешены все расширения <br><br>Всегда в нижнем регистре, без точки в начале<br>  */
  @ActiveField({
    setter(model: AttributeRequirementsFile, prop: string, value: Array<string> | undefined, receiver?: AttributeRequirementsFile ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  extensions?: Array<string>
}
